import {useContext} from 'react';
import ConfirmContext from './ConfirmContext';
import {HIDE_CONFIRM, SHOW_CONFIRM} from "./Reducer";


function useConfirm() {
    const [confirmState, dispatch] = useContext(ConfirmContext);

    const onConfirm = () => {
        closeConfirm();
        confirmState.submitFn();

    };

    const onCancel = () => {
        closeConfirm();
        confirmState.cancelFn && confirmState.cancelFn();
    };
    const confirm = confirmParams => {
        dispatch({
            type: SHOW_CONFIRM,
            payload: confirmParams
        });
    };

    const closeConfirm = () => {
        dispatch({
            type: HIDE_CONFIRM
        });
    };

    return {confirm, onConfirm, onCancel, confirmState};
}

export default useConfirm;